import { create } from 'zustand'

export type ConnectionStatus = {
  status: 'connected' | 'disconnected' | 'reconnecting'
  reconnectIn?: number // milliseconds until reconnect
  timestamp?: number // timestamp of status change
}

export type Winner = 'player' | 'opponent' | 'tie'

type AppState = {
  updateState: <T>(key: string, value: T) => void
  loaded?: boolean
  userLoaded?: boolean
  delta?: number
  errors?: { [key: string]: string }
  loginSuccess?: boolean
  params?: { [key: string]: string }[]
  modalRuleStatus?: boolean
  modalExchangeStatus?: boolean
  modalHistoryStatus?: boolean
  modalMatchMakingStatus?: boolean
  modalMatchResultStatus?: boolean
  refreshSuccess?: boolean
  isPreparing?: boolean
  isDisconnected?: boolean

  stateLoaded?: boolean
  configLoaded?: boolean
  isAniming?: boolean
  bgImageLoaded?: boolean
  connectionStatus?: ConnectionStatus
  winner?: Winner
  getParam: (key: string) => string
  getError: (error: any) => string
}

export const useStore = create<AppState>((set, get) => ({
  loaded: false,
  userLoaded: false,
  delta: 0,
  errors: {},
  params: [],
  loginSuccess: false,
  modalRuleStatus: false,
  modalExchangeStatus: false,
  modalHistoryStatus: false,
  modalMatchMakingStatus: false,
  modalMatchResultStatus: false,
  isPreparing: false,
  isDisconnected: false,
  
  stateLoaded: false,
  configLoaded: false,
  isAniming: false,
  bgImageLoaded: false,
  gameState: null,
  connectionStatus: { status: 'connected', timestamp: Date.now() },
  opponentInfo: null,
  winner: 'tie',
  refreshSuccess: false,
  getParam: (key: string) => {
    const params = get().params
    return params?.[key as any] as any
  },
  getError: (error: any) => {
    const errors = get().errors
    const key = (error?.code || error?.message) as string
    return errors?.[key] || `Hệ thống chưa thể thực hiện thao tác của bạn: ${key}`
  },
  updateState: <T>(key: string, value: T) => set(() => ({
    [key]: value
  }))
} as any as AppState))